import { Switch } from '@components/ui/switch'
import { AdasBox, AdasImage, AdasTextField, AdasTypography } from '@components/wrapper-components'
import { InfoPopover } from '@components/popover'

export const InvoiceSettings = ({
  optInQR,
  handleQROptIn,
  optInPayNow,
  handlePayNowOptIn,
  payNowUrl,
  handlePayNowUrlChange,
  handlePayNowUrlBlur
}) => {
  return (
    <AdasBox className='mt-6'>
      <AdasTypography className='text-[20px] font-bold text-foreground mb-4'>Invoice Settings</AdasTypography>

      <AdasBox className='rounded-xl border border-border bg-white p-5 space-y-5'>
        <AdasBox className='flex items-start justify-between gap-4'>
          <AdasBox className='min-w-0 flex-1'>
            <AdasBox className='flex items-center gap-1'>
              <AdasTypography className='text-[15px] font-semibold text-foreground'>
                Display Invoice QR code & URL on Invoice PDF
              </AdasTypography>
              <InfoPopover
                ariaLabel='Sample Invoice with QR code & url'
                enableClick={true}
                popoverWidth='150px'
                className='p-0'
                text={<AdasImage src='sample_invoice.png' className='w-full' />}
              />
            </AdasBox>
            <AdasTypography className='text-[13px] text-muted-foreground mt-0.5'>
              Allow customers to scan QR code to view invoice online
            </AdasTypography>
          </AdasBox>
          <Switch
            checked={!!optInQR}
            onCheckedChange={(next) => handleQROptIn({ target: { value: next ? 'Yes' : 'No' } })}
            aria-label='Toggle QR code on invoice PDF'
          />
        </AdasBox>

        <hr className='border-border' />

        <AdasBox className='flex items-start justify-between gap-4'>
          <AdasBox className='min-w-0 flex-1'>
            <AdasTypography className='text-[15px] font-semibold text-foreground'>Display Pay Now on Invoice PDF</AdasTypography>
            <AdasTypography className='text-[13px] text-muted-foreground mt-0.5'>
              Show payment button for online credit card payments
            </AdasTypography>
          </AdasBox>
          <Switch
            checked={!!optInPayNow}
            onCheckedChange={(next) => handlePayNowOptIn({ target: { value: next ? 'Yes' : 'No' } })}
            aria-label='Toggle Pay Now on invoice PDF'
          />
        </AdasBox>

        {optInPayNow && (
          <AdasBox>
            <AdasTextField
              fullWidth
              placeholder='Paste payment link URL here'
              value={payNowUrl}
              onChange={handlePayNowUrlChange}
              onBlur={handlePayNowUrlBlur}
              disabled={!optInPayNow}
            />
          </AdasBox>
        )}
      </AdasBox>
    </AdasBox>
  )
}
